/// Menu
import MetisMenu from "metismenujs";
import React, { Component } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import { Link } from "react-router-dom";

import { CiMobile4 } from 'react-icons/ci';
class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new MetisMenu(this.$el);
  }
  componentWillUnmount() {}
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

class SideBar extends Component {
  /// Open menu
  componentDidMount() {
    // sidebar open/close
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");
    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }
    btn.addEventListener("click", toggleFunc);
  }
  state = {
    loveEmoji: false,
  };
  render() {
    /// Path
    let path = window.location.pathname;
    path = path.split("/");
    path = path[path.length - 1];

    /// Active menu
    let users = ["user-management", ""],
      vipUsers = ["vip-users-management"],
      table = ["tax-management"],
      classifier = ["classifier-settings"],
      ocrTestSuite = ["ocr-test-suite"],
      testCompanies = ["test-companies"];

    return (
      <div className="deznav">
        <PerfectScrollbar className="deznav-scroll">
          <MM className="metismenu" id="menu">
            <li className={`${users.includes(path) ? "mm-active" : ""}`}>
              <Link to="user-management" className="ai-icon">
                <i className="flaticon-381-user-9"></i>

                <span className="nav-text">Company Management</span>
              </Link>
            </li>
            <li className={`${vipUsers.includes(path) ? "mm-active" : ""}`}>
              <Link to="vip-users-management" className="ai-icon">
                <i className="flaticon-381-user-9"></i>

                <span className="nav-text">VIP Users</span>
              </Link>
            </li>
            <li className={`${table.includes(path) ? "mm-active" : ""}`}>
              <Link to="tax-management" className="ai-icon">
                <i className="flaticon-381-list"></i>

                <span className="nav-text">Tax Management</span>
              </Link>
            </li>
            <li className={`${path.includes('app-version-management') ? "mm-active" : ""}`}>
              <Link to="app-version-management">
                <CiMobile4 size={22} strokeWidth={1} style={{marginRight:"20px"}} color={path.includes('app-version-management') ? "" : "gray"}  />
                <span className="nav-text">App Version</span>
              </Link>
            </li>
            <li className={`${classifier.includes(path) ? "mm-active" : ""}`}>
              <Link to="classifier-settings" className="ai-icon">
                <i className="flaticon-381-settings-6"></i>
                <span className="nav-text">Classifier</span>
              </Link>
            </li>
            <li className={`${path.includes('error-telemetry') ? "mm-active" : ""}`}>
              <Link to="error-telemetry" className="ai-icon">
                <i className="flaticon-381-warning"></i>
                <span className="nav-text">Error Telemetry</span>
              </Link>
            </li>
            <li className={`${ocrTestSuite.includes(path) ? "mm-active" : ""}`}>
              <Link to="ocr-test-suite" className="ai-icon">
                <i className="flaticon-381-network"></i>
                <span className="nav-text">OCR Test Suite</span>
              </Link>
            </li>
            <li className={`${testCompanies.includes(path) ? "mm-active" : ""}`}>
              <Link to="test-companies" className="ai-icon">
                <i className="flaticon-381-briefcase"></i>
                <span className="nav-text">Test Companies</span>
              </Link>
            </li>
          </MM>
        </PerfectScrollbar>
      </div>
    );
  }
}

export default SideBar;
